<script lang="ts" setup>
import { SolAlert, SolInputText } from '@solfacil/girassol'

const props = withDefaults(defineProps<{
  variant?: 'combo' | 'container'
}>(), {
  variant: 'combo',
})

const { t } = useI18n()

const isContainer = computed(() => props.variant === 'container')
const distributorName = computed(() => t('project_data.equipment_summary.distributor_name'))
</script>

<template>
  <div class="flex flex-col">
    <section class="flex flex-col gap-4">
      <h3 class="fonts-heading-h3 text-neutral-low-dark">
        {{ t('project_data.equipment_summary.title') }}
      </h3>

      <template v-if="isContainer">
        <div class="w-full flex flex-col gap-1">
          <SolInputText
            id="equipment-distributor"
            name="equipment_distributor"
            class="w-full"
            :model-value="distributorName"
            :label="t('project_data.equipment_summary.distributor')"
            :disabled="true"
          />
          <span class="fonts-body-small-regular text-neutral-low-light">
            {{ t('project_data.equipment_summary.container_helper') }}
          </span>
        </div>
      </template>

      <template v-else>
        <SolInputText
          id="equipment-distributor"
          name="equipment_distributor"
          class="w-full"
          :model-value="distributorName"
          :label="t('project_data.equipment_summary.distributor')"
          :required="true"
          :disabled="true"
        />

        <SolAlert
          id="equipment-paid-directly"
          feedback="informative"
          :text="t('project_data.equipment_summary.paid_directly')"
        />
      </template>
    </section>
  </div>
</template>
